import LineListTable from './lineListTable'
export default LineListTable
